export default "__VITE_ASSET__BqhgOQzN__"